import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=5a254d36&scoped=true&"
import script from "./TheNavbar.vue?vue&type=script&lang=js&"
export * from "./TheNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=5a254d36&scoped=true&lang=css&"
import style1 from "./TheNavbar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a254d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a254d36')) {
      api.createRecord('5a254d36', component.options)
    } else {
      api.reload('5a254d36', component.options)
    }
    module.hot.accept("./TheNavbar.vue?vue&type=template&id=5a254d36&scoped=true&", function () {
      api.rerender('5a254d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuperAdmin/TheNavbar.vue"
export default component.exports